import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import Reveal from "./Reveal";
import { IMAGES } from "@/data";
import { useLang } from "@/i18n/LangContext";

const Manifesto = () => {
  const { t, content } = useLang();
  const MANIFESTO = content.manifesto;
  return (
  <section id="manifiesto" data-testid="manifesto-section" className="relative py-28 lg:py-36 overflow-hidden">
    <div className="absolute inset-0">
      <img
        src={IMAGES.typewriter}
        alt=""
        aria-hidden="true"
        className="w-full h-full object-cover opacity-[0.07]"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0D0D0E] via-transparent to-[#0D0D0E]" />
    </div>

    <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-[1fr_1.4fr] gap-14 lg:gap-20">
      <Reveal>
        <p className="font-code text-xs tracking-[0.35em] uppercase text-[#C5A059] mb-4">
          {t("manifesto.overline")}
        </p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#F4F1EA] tracking-tight leading-tight">
          {t("manifesto.headingA")} <span className="italic text-[#D4AF37]">{t("manifesto.headingB")}</span>
        </h2>
        <p className="mt-6 text-[#A0A0A5] leading-relaxed">
          {t("manifesto.intro")}
        </p>
        <div className="mt-10 h-px w-24 bg-gradient-to-r from-[#D4AF37] to-transparent" />
      </Reveal>

      <Reveal delay={0.15}>
        <Accordion type="single" collapsible defaultValue="cap-0" data-testid="manifesto-accordion">
          {MANIFESTO.map((cap, i) => (
            <AccordionItem
              key={cap.num}
              value={`cap-${i}`}
              className="border-b border-[#F4F1EA]/10"
              data-testid={`manifesto-item-${i}`}
            >
              <AccordionTrigger
                data-testid={`manifesto-trigger-${i}`}
                className="group py-7 hover:no-underline text-left"
              >
                <span className="flex items-baseline gap-6">
                  <span className="font-code text-sm text-[#D4AF37] tracking-[0.2em]">{cap.num}</span>
                  <span className="font-display text-xl sm:text-2xl text-[#F4F1EA] group-hover:text-[#E5C158] transition-colors duration-300">
                    {cap.title}
                  </span>
                </span>
              </AccordionTrigger>
              <AccordionContent className="pb-8 pl-0 sm:pl-14">
                <p className="text-[#A0A0A5] leading-relaxed">{cap.body}</p>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
  );
};

export default Manifesto;
